/* src/components/pdf-page-risks-and-opportunities-content/pdf-page-risks-and-opportunities-content.component.scss */
app-pdf-page-risks-and-opportunities-content {
  display: block;
}
app-pdf-page-risks-and-opportunities-content .sortable-label {
  position: relative;
  cursor: pointer;
}
app-pdf-page-risks-and-opportunities-content .sortable-label:hover .sortable-label__icon,
app-pdf-page-risks-and-opportunities-content .sortable-label--active .sortable-label__icon {
  opacity: 1;
}
app-pdf-page-risks-and-opportunities-content .sortable-label__text {
  display: inline-block;
  padding-right: 5px;
}
app-pdf-page-risks-and-opportunities-content .sortable-label__icon {
  opacity: 0;
  position: absolute;
  top: 10px;
  right: 10px;
}
app-pdf-page-risks-and-opportunities-content .clickable_cell {
  cursor: pointer;
}
app-pdf-page-risks-and-opportunities-content .clickable_cell:hover,
app-pdf-page-risks-and-opportunities-content .clickable_cell:focus-visible {
  background: rgba(0, 0, 0, 0.05);
}
/*# sourceMappingURL=pdf-page-risks-and-opportunities-content.component-JJ7ABPV5.css.map */
